import React, { useState } from 'react';
import { Box, FormLabel, Menu } from '@chakra-ui/react';
import { localise } from '../../../../services/lang/lang';
import { RoleOption } from '../../../../types/enums/Role';
import MultiFilter from '../../../modules/MultiFilter/MultiFilter';
const PermissionFilterWrapper = ({ onApply }) => {
    const [rolesFilter, setRolesFilter] = useState([
        RoleOption.Inspector.toString(),
    ]);
    const roleMultiSelectOptions = [
        {
            title: '',
            selectedValues: rolesFilter.filter((role) => [
                RoleOption.Inspector.toString(),
                RoleOption.TeamManager.toString(),
            ].includes(role)),
            items: [
                {
                    title: localise('ROLE_INSPECTOR'),
                    value: RoleOption.Inspector.toString(),
                    isDisabled: true,
                },
                {
                    title: localise('ROLE_TEAM_MANAGEMENT'),
                    value: RoleOption.TeamManager.toString(),
                    isDisabled: false,
                },
            ],
        },
        {
            title: localise('ROLE_ADVANCED'),
            selectedValues: rolesFilter.filter((role) => [RoleOption.OrganisationManager.toString()].includes(role.toString())),
            items: [
                {
                    title: localise('ROLE_ORGANISATION_MANAGEMENT'),
                    value: RoleOption.OrganisationManager.toString(),
                    isDisabled: false,
                },
            ],
        },
    ];
    const handleApply = (values) => {
        setRolesFilter(values);
        onApply(values.map((value) => Number(value)));
    };
    return (React.createElement(Box, { mt: "-25px" },
        React.createElement(FormLabel, { "data-testid": "permission_filter__form_label" }, localise('PERMISSIONS_CONTAINS')),
        React.createElement(Menu, { closeOnSelect: false, variant: "multi-select" },
            React.createElement(MultiFilter, { hasOneAlwaysSelected: true, selectionGroups: roleMultiSelectOptions, selectedValues: rolesFilter, onApply: handleApply }))));
};
export default PermissionFilterWrapper;
